// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"7601f4a510e943eae33a","678":"2e470c287f11f70be1c1"}[chunkId] + ".js";
};